export const AVISO_EMPENDENCIA_STORAGE_KEY = "mostrarAvisoEmpendencia";

export const MENSAGEM_AVISO_EMPENDENCIA =
  "O município encontra-se em débito. Para evitar a perda do acesso, entre em contato com o suporte para regularizar a situação.";

export const AVISO_EMPENDENCIA_DURACAO_MS = 10000;

export function marcarAvisoEmpendenciaPendente() {
  sessionStorage.setItem(AVISO_EMPENDENCIA_STORAGE_KEY, "true");
}

export function consumirAvisoEmpendenciaPendente() {
  const pendente = sessionStorage.getItem(AVISO_EMPENDENCIA_STORAGE_KEY) === "true";
  if (pendente) {
    sessionStorage.removeItem(AVISO_EMPENDENCIA_STORAGE_KEY);
  }
  return pendente;
}

export function deveMarcarAvisoEmpendencia(empendenciaAtiva, userData) {
  if (!empendenciaAtiva || !userData?.data) {
    return false;
  }
  return !!(userData.data.isAnalista || userData.data.isSecretario);
}
